import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
// Import components
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Import pages
import HomePage from './pages/HomePage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SubscriptionPage from './pages/SubscriptionPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import ContactPage from './pages/ContactPage';
// Project Management Pages
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ProjectTasksPage from './pages/ProjectTasksPage';
import ProjectDashboardPage from './pages/ProjectDashboardPage';
import ReportsPage from './pages/ReportsPage';
import ProjectVisualizerPage from './pages/ProjectVisualizerPage'; 
import RiskManagementPage from './pages/RiskManagementPage';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <CssBaseline />
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: 'background.default'
          }}>
            <Navbar />
            
            <Box 
              component="main" 
              sx={{ 
                flexGrow: 1, 
                px: { xs: 2, sm: 3, md: 4 }, 
                py: { xs: 2, sm: 3, md: 4 },
                maxWidth: '100%',
                width: '100%',
                mx: 'auto'
              }}
            >
              <Routes>
                {/* Basic routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
                <Route path="/unauthorized" element={<UnauthorizedPage />} />
                <Route path="/contact" element={<ContactPage />} />
                              
                            
                {/* Project Management routes */}
                <Route path="/projects" element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ProjectsPage />
                  </ProtectedRoute>
                } />
                
                <Route path="/projects/:projectId" element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ProjectDetailPage />
                  </ProtectedRoute>
                } />
                
                <Route path="/projects/:projectId/tasks" element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ProjectTasksPage />
                  </ProtectedRoute>
                } />
                
                <Route path="/risks" element={
                <ProtectedRoute roles={['admin', 'editor']}>
                <RiskManagementPage />
                </ProtectedRoute>
                } />
                
                <Route path="/project-dashboard" element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ProjectDashboardPage />
                  </ProtectedRoute>
                } />
                
                <Route path="/reports" element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ReportsPage />
                  </ProtectedRoute>
                } />
                
                <Route path="/project-visualizer" element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ProjectVisualizerPage />
                  </ProtectedRoute>
                } />
                
                {/* Catch-all route for 404 */}
                <Route path="*" element={
                  <Box sx={{ textAlign: 'center', py: 8 }}>
                    <h1>404: Page Not Found</h1>
                    <p>The page you're looking for doesn't exist.</p>
                  </Box>
                } />
              </Routes>
            </Box>
            
            <Footer />
          </Box>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
